import { getImageUrl } from "src/Common/common";
import { Oval } from "react-loader-spinner";

function UploadButton({ onClicked, isLoading }) {
  return (
    <div
      onClick={isLoading ? undefined : onClicked}
      className={`bg-blueColor rounded-[6px] w-[89px] h-[30px] flex items-center justify-center gap-1 ${isLoading ? "cursor-not-allowed opacity-70" : "cursor-pointer"}`}
    >
      {isLoading ? (
        <Oval
          visible={true}
          height="16"
          width="16"
          color="#FFFFFF"
          strokeWidth={8}
          secondaryColor="#FFFFFF"
          ariaLabel="oval-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      ) : (
        <>
          <img src={getImageUrl("/images/common/upload_white.png")} />

          <span className="font-OpenSansRegular font-[500] text-[10px] text-white">UPLOAD</span>
        </>
      )}
    </div>
  );
}

export default UploadButton;
